import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { SettingsState } from '@core/settings';

import { SoundTogglerComponent } from '../../components/sound-toggler/sound-toggler.component';
import { WrapperState } from '../../wrapper.state';

@Component({
  selector: 'dialog-settings',
  templateUrl: './settings.dialog.html',
  styleUrl: './settings.dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SoundTogglerComponent]
})
export class SettingsDialog {
  public readonly dialogRef = inject(DialogRef);
  public readonly settingsState = inject(SettingsState);

  private readonly wrapperState = inject(WrapperState);

  toggleDisableAnimations(): void {
    this.settingsState.toggleDisableAnimations();

    if (this.settingsState.disableAnimations()) {
      this.wrapperState.addClass('animations_off');
    } else {
      this.wrapperState.removeClass('animations_off');
    }
  }

  toggleStreamerMode(): void {
    this.settingsState.toggleStreamerMode();

    if (this.settingsState.streamerMode()) {
      this.wrapperState.addClass('streamer_mode');
    } else {
      this.wrapperState.removeClass('streamer_mode');
    }
  }

  toggleStretchDesign(): void {
    this.settingsState.toggleStretchDesign();
  }

  toggleCrashTwoBets(): void {
    this.settingsState.toggleCrashTwoBets();
  }

  toggleStickersEnabled(): void {
    this.settingsState.toggleStickersEnabled();
  }
}
